import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Icon } from 'loyal-react'
import { Link } from 'react-router-dom'

const BackButton = ({ history, mobile }) => (
  <div className='backButton col-md-auto col-2 pr-0 ml-0 ml-md-auto'>
    <div className='row align-items-center h-100'>
      <div className='col-12 px-1 txt-left'>
        <Link
          className={`btn-back-page ${mobile ? 'btn-back-page-mobile' : 'btn-back-page-desktop'} p-1 px-2 btn-sm btn-flat color-ui-white border-none btn-icon txt-button txt-font-body`}
          to='/cart'
          aria-label='Voltar'
        >
          <Icon
            className='icon icon-sm color-ui-white'
            iconName='icon_left_app'
          />
          <span className='d-none d-md-inline-block color-ui-white border-bottom pl-2' aria-hidden>Voltar</span>
        </Link>
      </div>
    </div>
  </div>
)

BackButton.propTypes = {
  history: PropTypes.object,
  mobile: PropTypes.bool
}
export default withRouter(BackButton)



// WEBPACK FOOTER //
// ./src/App/Header/BackButton/BackButtonDesktop.js